import React, {useState} from 'react';
import {get} from 'lodash-es';

export default function useForm (values_={}, DEFAULT_VALUES={}) {
  const [ values, setValues ] = useState({...DEFAULT_VALUES, ...values_})
  const setValue = name => event => (
    setValues({ ...values, [name]: event.target.value })
  )
  const getValue = (name) => get(values, name)
  const toggleBool = name => () => (
    setValues({ ...values, [name]: !values[name] })
  )
  //////////////////////
  const [ errors, setErrors ] = useState({})
  const getError = (name) => get(errors, name)
  const setError = (name, message) => (
    setErrors({ ...errors, [name]: message })
  )
  const hasError = name => Boolean(getError(name))
  //////////////////////
  const [ touch, setTouch_ ] = useState([])
  const setTouch = name => () => {
    if (!touch.includes(name)) {
      setTouch_([...touch, name])
    }
  }
  const wasTouched = name => touch.includes(name)
  return {
    values,
    setValues,
    setValue,
    getValue,
    toggleBool,
    errors,
    setErrors,
    hasError,
    getError,
    setError,
    touch,
    setTouch,
    wasTouched,
  }
}
